import { useState } from "react";
import { toast } from "react-toastify";
import PageHeader from "../../Component/PageHeader";
import Pill from "../../Component/Pill";
import { DemoFlag, FLAGS, PLAN_NAMES } from "../../utils/staticData";

// STATIC DESIGN — flags live in local state until the feature-flag API exists
const stageTone = (stage: string) => (stage === "GA" ? "ok" : stage === "Beta" ? "blue" : "warn");

const FeatureFlags = () => {
  const [flags, setFlags] = useState<DemoFlag[]>(FLAGS);

  const toggle = (key: string, plan: string, on: boolean) => {
    setFlags(list => list.map(f => (f.key === key ? { ...f, plans: { ...f.plans, [plan]: on } } : f)));
    const flag = flags.find(f => f.key === key);
    toast.success(`${flag?.name} · ${plan} → ${on ? "ON" : "OFF"}`);
  };

  return (
    <div className="container-fluid">
      <div className="cx">
        <PageHeader
          crumb="Feature flags"
          title="Feature flags"
          sub="Turn new features on or off per plan without a deploy. Client-specific overrides are set from the customer's page."
          actions={<button type="button" className="cx-btn cx-btn-primary" onClick={() => toast.info("New flag drafted")}><i className="ri-add-line"></i>New flag</button>}
        />

        <div className="cx-card">
          <div className="cx-tbl-wrap">
            <table className="cx-tbl center">
              <thead>
                <tr><th>Feature</th>{PLAN_NAMES.map(p => <th key={p}>{p}</th>)}<th>Stage</th></tr>
              </thead>
              <tbody>
                {flags.map(f => (
                  <tr key={f.key}>
                    <td>
                      <b style={{ fontSize: 13 }}>{f.name}</b>
                      <div className="fs12 muted">{f.desc} · <span className="mono">{f.key}</span></div>
                    </td>
                    {PLAN_NAMES.map(p => (
                      <td key={p}>
                        <label className="cx-switch" title={`${f.name} on ${p}`}>
                          <input type="checkbox" checked={!!f.plans[p]} onChange={(e) => toggle(f.key, p, e.target.checked)} />
                          <span></span>
                        </label>
                      </td>
                    ))}
                    <td><Pill tone={stageTone(f.stage)}>{f.stage}</Pill></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureFlags;
